/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import axios from "axios";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MDButton from "components/MDButton";
import { useState, useEffect } from "react";
import FormControl from "@mui/material/FormControl";
import MDBackdrop from "components/MDBackdrop";
import { useSnackbar } from "notistack";
import CloseIcon from "@mui/icons-material/Close";
import { useMaterialUIController } from "context";
import theme from "assets/theme";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import IconButton from "@mui/material/IconButton";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Completion from "./Completion";
import useApiRequest from "utils/Apirequest";
import { Autocomplete, TextField } from "@mui/material";
import { CircularProgress } from "@mui/material";
import { allowOnlyAlphanumericAndSpace } from "utils/Constant";
import { isValidEmail } from "utils/Constant";
import { isValidDriverId } from "utils/Constant";
import { isValidPhone } from "utils/Constant";
import dayjs from "dayjs";

const NAME_MAX = 35;
const DRIVER_ID_MAX = 30;

const initialValues = {
  first_name: "",
  last_name: "",
  email: "",
  gender: "",
  date_of_birth: "",
  rfidTag: "",
  phone_number: "",
  password: "",
};

function PopAddUser(props) {
  const [controller] = useMaterialUIController();
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const { darkMode, sidenavColor } = controller;
  const [isDisabled, setIsDisabled] = useState(false);
  const [isBackdrop, setIsBackdrop] = useState(false);
  const { onClose } = props;
  const [showPassword, setShowPassword] = useState(false);
  const apiRequest = useApiRequest();
  const [searchInput, setSearchInput] = useState("");
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [errors, setErrors] = useState({});
  const [values, setValues] = useState(initialValues);
  const { enqueueSnackbar } = useSnackbar();

  const fetchVehicles = async (searchTerm = "") => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASEURL}vehicle/search/query?query=${searchTerm}`,
        {
          withCredentials: true,
        }
      );
      setResults(res?.data?.data || []);
    } catch (err) {
      console.error("Search error:", err);
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  const assignVehicle = async () => {
    if (!selectedVehicle) {
      return enqueueSnackbar("All fields are necessary", { variant: "error" });
    }


    const payload = {
      ARAI_range: selectedVehicle.ARAI_range,
      claimed_range: selectedVehicle.claimed_range,
      connector_type: selectedVehicle.connector_type,
      vehicle_img: selectedVehicle.image,
      vehicle_reg: selectedVehicle?.vehicle_reg,
      make: selectedVehicle.make,
      model: selectedVehicle.model,
      type: selectedVehicle.type,
      variant: selectedVehicle.variant,
      battery_capacity: selectedVehicle.battery_capacity,
    };

    const { data } =
      (await apiRequest(
        "post",
        "users/user/" + values.rfidTag + "/vehicles",
        payload,
        {},
        {}
      )) || {};
    if (data?.success === true) {
    }
  };

  const parseDate = (dateString) => {
    if (!dateString) return "";

    const [year, month, day] = dateString.split("-");

    const paddedDay = day.padStart(2, "0");
    const paddedMonth = month.padStart(2, "0");

    return `${paddedDay}/${paddedMonth}/${year}`;
  };
  const createUser = async () => {
    onClose(false);

    const payload = {
      firstName: values?.first_name,
      lastName: values?.last_name,
      email: values?.email,
      gender: values?.gender,
      dob: parseDate(values?.date_of_birth),
      city: values?.city,
      state: values?.state,
      phoneNumber: values?.phone_number,
      DriverId: values?.rfidTag,
      password: values?.password,
    };
    const { data } =
      (await apiRequest(
        "post",
        "users/user/driver",
        payload,
        {},
        {
          "Content-Type": "application/json",
        }
      )) || {};
    if (data?.success === true) {
      setIsDisabled(!isDisabled);
      if (selectedVehicle) {
        assignVehicle();
      }
    }
  };

  console.log("Selected Vehicle:", selectedVehicle);

  useEffect(() => {
    if (props.isDialog) {
      setValues(initialValues);
      setErrors({});
      setSelectedVehicle(null);
      setSearchInput("");
      setQuery("");
      setResults([]);
      setShowPassword(false);
    }
  }, [props.isDialog]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setValues((prevValues) => ({
      ...prevValues,
      [event.target.name]: event.target.value,
    }));
  };

  const handleVehicleChange = async (e) => {
    const selectedObj = e.target.value;
    if (selectedObj) {
      setSearchInput(
        `${selectedObj?.make} ${selectedObj?.model} ${selectedObj?.variant}`
      );
    }
    setSelectedVehicle(selectedObj);
    setQuery(
      `${selectedObj?.make} ${selectedObj?.model} ${selectedObj?.variant}`
    );
  };

  const reset = (event) => {
    event.preventDefault();
    setValues(props.value);
  };
  const handleClose = () => {
    onClose(false);
  };

  const pop = () => {
    values.type = selectedVehicle?.type;
    values.make = selectedVehicle?.make;
    values.model = selectedVehicle?.model;
    values.variant = selectedVehicle?.variant;
    values.registeration_number = selectedVehicle?.vehicle_reg;
    values.vehicle_img = selectedVehicle?.image;
    if (!values.first_name || !values.rfidTag || !values.password || !values.phone_number)
      return enqueueSnackbar("Please Fill All Necessary Details !!!", {
        variant: "error",
        autoHideDuration: 2000,
      });

    if (/\s/.test(values.password)) {
      return enqueueSnackbar("Password should not contain spaces", {
        variant: "error",
        autoHideDuration: 2000,
      });
    }


    setIsBackdrop(false);
    onClose(false);
    createUser();
  };

  return (
    <>
      <Completion
        isDialog={isDisabled}
        onClose={setIsDisabled}
        value={values}
      />
      <MDBackdrop isBackdrop={isBackdrop} />
      <Dialog
        open={props.isDialog}
        onClose={handleClose}
        fullWidth={false} //  stop stretching
        PaperProps={{
          sx: {
            width: 1000, // exact width (adjust if needed)
            borderRadius: "12px",
          },
        }}
      >
        <DialogTitle
          style={
            darkMode
              ? {
                backgroundColor: "#202940",
                color: "#ffffff",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }
              : {
                theme,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }
          }
        >
          Driver information
          <IconButton
            aria-label="delete"
            onClick={handleClose}
            style={darkMode ? { color: "#ffffff" } : theme}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          style={
            darkMode ? { backgroundColor: "#202940", color: "#ffffff" } : theme
          }
        >
          <MDBox pt={0} pb={0} px={3}>
            <MDBox pt={0}></MDBox>

            <MDBox p={2} component="form" role="form">
              <MDBox p={1}>
                <MDInput
                  type="text"
                  label="First Name"
                  name="first_name"
                  value={values.first_name}
                  margin="dense"
                  fullWidth
                  inputProps={{ maxLength: 35 }}
                  onKeyPress={(e) => {
                    if (!/^[a-zA-Z0-9\s]$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onChange={handleChange}
                  onBlur={(e) => {
                    const value = e.target.value;

                    setErrors((prev) => ({
                      ...prev,
                      first_name:
                        value.length < 2
                          ? "Minimum 2 characters required"
                          : value.length > 35
                            ? "Maximum 35 characters allowed"
                            : /^\d+$/.test(value)
                              ? "Numbers only are not allowed"
                              : allowOnlyAlphanumericAndSpace(value)
                                ? ""
                                : "Only letters are allowed",
                    }));
                  }}
                  error={Boolean(errors.first_name)}
                  helperText={
                    errors.first_name
                  }
                  FormHelperTextProps={{
                    sx: {
                      color: errors.first_name ? "#d32f2f" : "text.secondary",
                      fontSize: "12px",
                      marginLeft: "4px",
                    },
                  }}
                />
              </MDBox>

              <MDBox p={1}>
                <MDInput
                  type="text"
                  label="Last Name"
                  name="last_name"
                  value={values.last_name}
                  margin="dense"
                  fullWidth
                  inputProps={{ maxLength: 35 }}
                  onKeyPress={(e) => {
                    if (!/^[a-zA-Z0-9\s]$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onChange={handleChange}
                  onBlur={(e) => {
                    const value = e.target.value;

                    setErrors((prev) => ({
                      ...prev,
                      last_name:
                        value.length < 2
                          ? "Minimum 2 characters required"
                          : value.length > 35
                            ? "Maximum 35 characters allowed"
                            : /^\d+$/.test(value)
                              ? "Numbers only are not allowed"
                              : allowOnlyAlphanumericAndSpace(value)
                                ? ""
                                : "Only letters are allowed",
                    }));
                  }}
                  error={Boolean(errors.last_name)}
                  helperText={
                    errors.last_name
                  }
                  FormHelperTextProps={{
                    sx: {
                      color: errors.last_name ? "#d32f2f" : "text.secondary",
                      fontSize: "12px",
                      marginLeft: "4px",
                    },
                  }}
                />
              </MDBox>

              <MDBox p={1}>
                <MDInput
                  type="email"
                  label="E-mail ID"
                  name="email"
                  value={values.email}
                  placeholder="username@gmail.com"
                  margin="dense"
                  fullWidth
                  onChange={handleChange}
                  onBlur={(e) => {
                    const value = e.target.value;

                    setErrors((prev) => ({
                      ...prev,
                      email: isValidEmail(value)
                        ? ""
                        : "Enter a valid email address",
                    }));
                  }}
                  error={Boolean(errors.email)}
                  helperText={errors.email}
                  FormHelperTextProps={{
                    sx: {
                      color: "#d32f2f",
                      fontSize: "12px",
                      marginLeft: "4px",
                    },
                  }}
                />
              </MDBox>
              <MDBox p={1}>
                <MDInput
                  type="tel"
                  label="Phone Number"
                  value={values.phone_number}
                  name="phone_number"
                  fullWidth
                  onChange={handleChange}
                  onBlur={(e) => {
                    const value = e.target.value;

                    setErrors((prev) => ({
                      ...prev,
                      phone_number: isValidPhone(value)
                        ? ""
                        : "Enter a valid Phone Number",
                    }));
                  }}
                  error={Boolean(errors.phone_number)}
                  helperText={errors.phone_number}
                  sx={{
                    "& .MuiFormHelperText-root": {
                      color: "error.main",
                    },
                    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline":
                    {
                      borderColor: "error.main",
                    },
                  }}
                />
              </MDBox>
              <MDBox p={1}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Gender</InputLabel>
                  <Select
                    sx={{
                      height: 50,

                      "& .MuiSelect-iconOutlined": {
                        display: "block",
                        visibility: "visible",
                        color: "#6b6b6b",
                        right: 12,
                      },

                      "& .MuiOutlinedInput-root": {
                        paddingRight: "32px", // space for arrow
                      },
                    }}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={values.gender}
                    label="Gender"
                    name="gender"
                    onChange={handleChange}
                    IconComponent={ArrowDropDownIcon}
                  >
                    <MenuItem value={"Male"}>Male</MenuItem>
                    <MenuItem value={"Female"}>Female</MenuItem>
                  </Select>
                </FormControl>
              </MDBox>
              <MDBox p={1}>
                <FormControl fullWidth variant="outlined" margin="dense">
                  <InputLabel shrink htmlFor="date-of-birth">
                    Date Of Birth
                  </InputLabel>
                  <OutlinedInput
                    id="date-of-birth"
                    type="date"
                    label="Date Of Birth"
                    name="date_of_birth"
                    value={values.date_of_birth}
                    onChange={handleChange}
                    inputProps={{
                      max: dayjs().format("YYYY-MM-DD"), // restrict future dates
                      onKeyDown: (e) => e.preventDefault(),
                    }}
                    notched
                  />
                </FormControl>
              </MDBox>


              <MDBox p={1}>
                <MDInput
                  type="text"
                  label="Driver ID"
                  name="rfidTag"
                  value={values.rfidTag}
                  margin="dense"
                  fullWidth
                  inputProps={{ maxLength: 30 }}
                  onKeyPress={(e) => {
                    if (!/^[a-zA-Z0-9\s]$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onChange={handleChange}
                  onBlur={(e) => {
                    const value = e.target.value;

                    setErrors((prev) => ({
                      ...prev,
                      rfidTag:
                        value.length < 3
                          ? "Minimum 3 characters required"
                          : value.length > 30
                            ? "Maximum 30 characters allowed"
                            : isValidDriverId(value)
                              ? ""
                              : "Driver ID must contain only numbers",
                    }));
                  }}
                  error={Boolean(errors.rfidTag)}
                  helperText={errors.rfidTag}
                  FormHelperTextProps={{
                    sx: {
                      color: errors.rfidTag ? "#d32f2f" : "text.secondary",
                      fontSize: "12px",
                      marginLeft: "4px",
                    },
                  }}
                />
              </MDBox>
              <MDBox p={1}>
                <MDInput
                  type={showPassword ? "text" : "password"}
                  label="Password"
                  value={values.password}
                  name="password"
                  margin="dense"
                  fullWidth
                  onChange={handleChange}
                  onBlur={(e) => {
                    const value = e.target.value;

                    setErrors((prev) => ({
                      ...prev,
                      password: /\s/.test(value)
                        ? "Password should not contain spaces"
                        : "",
                    }));
                  }}
                  error={Boolean(errors.password)}
                  helperText={errors.password}
                  FormHelperTextProps={{
                    sx: {
                      color: "error.main",
                      fontSize: "12px",
                      marginLeft: "4px",
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                        sx={{
                          transform: errors.password
                            ? "translateX(-28px)"
                            : "translateX(0px)",
                          transition: "transform 0.3s ease",
                        }}
                      >
                        {showPassword ? (
                          <VisibilityOffIcon />
                        ) : (
                          <VisibilityIcon />
                        )}
                      </IconButton>
                    ),
                  }}
                />

              </MDBox>

              <MDBox p={1}>
                <Autocomplete
                  fullWidth
                  id="select-vehicle"
                  options={results || []}
                  loading={loading}
                  getOptionLabel={(option) =>
                    option
                      ? `${option.vehicle_reg} - ${option.make} ${option.model} ${option.variant}`
                      : ""
                  }
                  value={selectedVehicle || null}
                  isOptionEqualToValue={(option, value) =>
                    option._id === value._id
                  }
                  onOpen={() => {
                    fetchVehicles("");
                  }}
                  onInputChange={(event, newInputValue) => {
                    fetchVehicles(newInputValue);
                  }}
                  onChange={(event, newValue) => {
                    const mockEvent = {
                      target: {
                        name: "vehicle",
                        value: newValue,
                      },
                    };
                    handleVehicleChange(mockEvent);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Vehicle"
                      placeholder="Search vehicle..."
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {loading ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props} key={option._id}>
                      {option.vehicle_reg} - {option.make} {option.model}{" "}
                      {option.variant}
                    </li>
                  )}
                />
              </MDBox>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions
          style={
            darkMode
              ? {
                backgroundColor: "#202940",
                justifyContent: "space-evenly",
                color: "#ffffff",
              }
              : { theme, justifyContent: "space-evenly" }
          }
        >
          <MDButton variant="gradient" color={sidenavColor} onClick={reset}>
            Reset
          </MDButton>
          <MDButton variant="gradient" color={sidenavColor} onClick={pop}>
            Submit
          </MDButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default PopAddUser;
